import { Typography, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FONT_GSS_FUTURA_SEMI_BOLD } from '@monorepo/shared/src/themes/defaultTheme';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import clsx from 'clsx';

type CommonTextButton = {
  text: string;
  onClick: (event: any) => void;
  icon?: IconProp;
  className?: string;
};

const CommonTextButton: React.FC<CommonTextButton> = ({ text, onClick, icon, className }) => {
  const classes = useStyles();
  return (
    <>
      <Button className={clsx(classes.button, className)} onClick={onClick}>
        {icon && <FontAwesomeIcon icon={icon} />}
        <Typography variant="subtitle1" color="primary">
          {text}
        </Typography>
      </Button>
    </>
  );
};
const useStyles = makeStyles((theme) => ({
  button: {
    fontSize: '1em',
    color: theme.palette.primary.main,
    '& svg': {
      alignSelf: 'center',
      marginRight: '6px',
    },
    '& h6': {
      alignSelf: 'center',
      fontFamily: FONT_GSS_FUTURA_SEMI_BOLD,
    },
  },
}));

export default CommonTextButton;
